const data = [
  {
    id: 'best-01',
    image: process.env.PUBLIC_URL+'/lika_img/product_1.jpg',
    banner: process.env.PUBLIC_URL+'/lika_img/product_1_1.jpg',
    detail: [
      process.env.PUBLIC_URL+'/lika_img/detail1/detail1_1.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail1/detail1_2.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail1/detail1_3.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail1/detail1_4.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail1/detail1_5.gif',
      process.env.PUBLIC_URL+'/lika_img/detail1/detail1_6.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail1/detail1_7.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail1/detail1_9.gif',
      process.env.PUBLIC_URL+'/lika_img/detail1/detail1_10.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail1/detail1_11.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail1/detail1_12.gif',
      process.env.PUBLIC_URL+'/lika_img/detail1/detail1_13.gif',
      process.env.PUBLIC_URL+'/lika_img/detail1/detail1_14.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail1/detail1_15.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail1/detail1_16.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail1/detail1_17.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail1/detail1_18.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail1/detail1_19.jpg'
  ],
    desc: '199,000원',
    title: '리뉴얼 리카백 이동가방',
    price: '143,200원',
    text: '반려인과 반려동물 모두를 위한 이동가방. 1년의 준비 기간과 7번의 샘플 과정 끝에, 리카리카가 자신있게 선보이는 리카백 입니다.',
    sort: '리빙',
    option: {
      size: ['M', 'L'],
      color: ['아이보리', '베이지']
    }
  },
  {
    id: 'best-02',
    image: process.env.PUBLIC_URL+'/lika_img/product_2.jpg',
    banner: process.env.PUBLIC_URL+'/lika_img/product_2_1.jpg',
    detail: [
      process.env.PUBLIC_URL+'/lika_img/detail2/detail2_1.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail2/detail2_2.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail2/detail2_3.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail2/detail2_4.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail2/detail2_5.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail2/detail2_6.gif',
      process.env.PUBLIC_URL+'/lika_img/detail2/detail2_7.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail2/detail2_8.gif',
      process.env.PUBLIC_URL+'/lika_img/detail2/detail2_9.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail2/detail2_10.gif',
      process.env.PUBLIC_URL+'/lika_img/detail2/detail2_11.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail2/detail2_12.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail2/detail2_13.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail2/detail2_14.gif',
      process.env.PUBLIC_URL+'/lika_img/detail2/detail2_15.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail2/detail2_16.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail2/detail2_17.gif',
      process.env.PUBLIC_URL+'/lika_img/detail2/detail2_18.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail2/detail2_19.gif',
      process.env.PUBLIC_URL+'/lika_img/detail2/detail2_20.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail2/detail2_21.gif',
      process.env.PUBLIC_URL+'/lika_img/detail2/detail2_22.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail2/detail2_23.gif',
      process.env.PUBLIC_URL+'/lika_img/detail2/detail2_24.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail2/detail2_25.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail2/detail2_26.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail2/detail2_27.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail2/detail2_28.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail2/detail2_29.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail2/detail2_30.jpg'
    ],
    desc: '199,000원',
    title: '에어쉘 카시트',
    price: '149,200원',
    text: '이제 안전하게 운전하세요! 소중한 내 가족을 위한 선택이 아닌 필수',
    sort: '리빙',
    option: {
      size: ['단품'],
      color: ['베이지']
    }
  },
  {
    id: 'best-03',
    image: process.env.PUBLIC_URL+'/lika_img/product_3.jpg',
    banner: process.env.PUBLIC_URL+'/lika_img/product_3_1.jpg',
    detail: [
      process.env.PUBLIC_URL+'/lika_img/detail3/detail3_1.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail3/detail3_2.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail3/detail3_3.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail3/detail3_4.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail3/detail3_5.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail3/detail3_6.gif',
      process.env.PUBLIC_URL+'/lika_img/detail3/detail3_7.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail3/detail3_8.gif',
      process.env.PUBLIC_URL+'/lika_img/detail3/detail3_9.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail3/detail3_10.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail3/detail3_11.gif',
      process.env.PUBLIC_URL+'/lika_img/detail3/detail3_12.gif',
      process.env.PUBLIC_URL+'/lika_img/detail3/detail3_13.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail3/detail3_14.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail3/detail3_15.gif',
      process.env.PUBLIC_URL+'/lika_img/detail3/detail3_16.gif',
      process.env.PUBLIC_URL+'/lika_img/detail3/detail3_17.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail3/detail3_18.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail3/detail3_19.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail3/detail3_20.gif',
      process.env.PUBLIC_URL+'/lika_img/detail3/detail3_21.gif',
      process.env.PUBLIC_URL+'/lika_img/detail3/detail3_22.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail3/detail3_23.gif',
      process.env.PUBLIC_URL+'/lika_img/detail3/detail3_24.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail3/detail3_25.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail3/detail3_26.gif',
      process.env.PUBLIC_URL+'/lika_img/detail3/detail3_27.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail3/detail3_28.gif',
      process.env.PUBLIC_URL+'/lika_img/detail3/detail3_29.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail3/detail3_30.gif',
      process.env.PUBLIC_URL+'/lika_img/detail3/detail3_31.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail3/detail3_32.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail3/detail3_33.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail3/detail3_34.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail3/detail3_35.jpg'
  ],
    desc: '199,000원',
    title: '쿠션백 이동가방',
    price: '155,200원',
    text: '더 넓어진 공간, 더 가벼운 무게',
    sort: '리빙',
    option: {
      size: ['M','L'],
      color: ['크림','차콜']
    }
  },
  {
    id: 'best-04',
    image: process.env.PUBLIC_URL+'/lika_img/product_4.jpg',
    banner: process.env.PUBLIC_URL+'/lika_img/product_4_1.jpg',
    detail: [
      process.env.PUBLIC_URL+'/lika_img/detail4/detail4_1.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail4/detail4_2.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail4/detail4_3.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail4/detail4_4.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail4/detail4_5.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail4/detail4_6.gif',
      process.env.PUBLIC_URL+'/lika_img/detail4/detail4_7.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail4/detail4_8.gif',
      process.env.PUBLIC_URL+'/lika_img/detail4/detail4_9.gif',
      process.env.PUBLIC_URL+'/lika_img/detail4/detail4_10.gif',
      process.env.PUBLIC_URL+'/lika_img/detail4/detail4_11.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail4/detail4_12.gif',
      process.env.PUBLIC_URL+'/lika_img/detail4/detail4_13.gif',
      process.env.PUBLIC_URL+'/lika_img/detail4/detail4_14.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail4/detail4_15.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail4/detail4_16.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail4/detail4_17.gif',
      process.env.PUBLIC_URL+'/lika_img/detail4/detail4_18.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail4/detail4_19.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail4/detail4_20.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail4/detail4_21.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail4/detail4_22.gif',
      process.env.PUBLIC_URL+'/lika_img/detail4/detail4_23.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail4/detail4_24.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail4/detail4_25.gif',
      process.env.PUBLIC_URL+'/lika_img/detail4/detail4_26.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail4/detail4_27.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail4/detail4_28.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail4/detail4_29.jpg'
    ],
    desc: '139,000원',
    title: '튼튼 반달 슬링백 확장형',
    price: '97,300원',
    text: '18cm 확장형 메쉬망으로 업그레이드!',
    sort: '리빙',
    option: {
      size: ['M','L'],
      color: ['크림','차콜']
    }
  },
  {
    id: 'best-05',
    image: process.env.PUBLIC_URL+'/lika_img/product_5.jpg',
    banner: process.env.PUBLIC_URL+'/lika_img/product_5_1.jpg',
    detail: [
      process.env.PUBLIC_URL+'/lika_img/detail5/detail5_1.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail5/detail5_2.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail5/detail5_3.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail5/detail5_4.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail5/detail5_5.gif',
      process.env.PUBLIC_URL+'/lika_img/detail5/detail5_6.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail5/detail5_7.gif',
      process.env.PUBLIC_URL+'/lika_img/detail5/detail5_8.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail5/detail5_9.gif',
      process.env.PUBLIC_URL+'/lika_img/detail5/detail5_10.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail5/detail5_11.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail5/detail5_12.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail5/detail5_13.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail5/detail5_14.gif',
      process.env.PUBLIC_URL+'/lika_img/detail5/detail5_15.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail5/detail5_16.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail5/detail5_17.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail5/detail5_18.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail5/detail5_19.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail5/detail5_20.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail5/detail5_21.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail5/detail5_22.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail5/detail5_23.jpg'
    ],
    desc: '58,000원',
    title: '코튼 캔디 L자형 산책용품 세트',
    price: '49,800원',
    text: '코튼 캔디 L자형 하네스와 리드줄 세트 상품입니다.',
    sort: '산책',
    option: {
      size: ['M','L'],
      color: ['아이보리','옐로우','베이비핑크','카키']
    }
  },
  {
    id: 'best-06',
    image: process.env.PUBLIC_URL+'/lika_img/product_6.jpg',
    banner: process.env.PUBLIC_URL+'/lika_img/product_6_1.jpg',
    detail: [
      process.env.PUBLIC_URL+'/lika_img/detail6/detail6_1.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail6/detail6_2.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail6/detail6_3.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail6/detail6_4.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail6/detail6_5.gif',
      process.env.PUBLIC_URL+'/lika_img/detail6/detail6_6.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail6/detail6_7.gif',
      process.env.PUBLIC_URL+'/lika_img/detail6/detail6_8.gif',
      process.env.PUBLIC_URL+'/lika_img/detail6/detail6_9.gif',
      process.env.PUBLIC_URL+'/lika_img/detail6/detail6_10.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail6/detail6_11.gif',
      process.env.PUBLIC_URL+'/lika_img/detail6/detail6_12.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail6/detail6_13.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail6/detail6_14.gif',
      process.env.PUBLIC_URL+'/lika_img/detail6/detail6_15.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail6/detail6_16.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail6/detail6_17.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail6/detail6_18.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail6/detail6_19.gif',
      process.env.PUBLIC_URL+'/lika_img/detail6/detail6_20.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail6/detail6_21.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail6/detail6_22.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail6/detail6_23.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail6/detail6_24.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail6/detail6_25.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail6/detail6_26.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail6/detail6_27.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail6/detail6_28.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail6/detail6_29.jpg'
    ],
    desc: '68,000원',
    title: '코튼 캔디 X자형 산책용품 세트',
    price: '59,000원',
    text: '코튼 캔디 X자형 하네스와 리드줄 세트 상품입니다.',
    sort: '산책',
    option: {
      size: ['S','M','L'],
      color: ['아이보리','옐로우','베이비핑크','카키']
    }
  },
  {
    id: 'best-07',
    image: process.env.PUBLIC_URL+'/lika_img/product_7.jpg',
    banner: process.env.PUBLIC_URL+'/lika_img/product_7_1.jpg',
    detail: [
      process.env.PUBLIC_URL+'/lika_img/detail7/detail7_1.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail7/detail7_2.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail7/detail7_3.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail7/detail7_4.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail7/detail7_5.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail7/detail7_6.gif',
      process.env.PUBLIC_URL+'/lika_img/detail7/detail7_7.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail7/detail7_8.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail7/detail7_9.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail7/detail7_10.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail7/detail7_11.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail7/detail7_12.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail7/detail7_13.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail7/detail7_14.jpg'
    ],
    desc: '35,000원',
    title: '플레이 포인트 티셔츠',
    price: '31,500원',
    text: '매일 입히고 싶은 편안함!',
    sort: '패션',
    option: {
      size: ['SM','M','L','XL','2XL'],
      color: ['머스터드','퍼플','네이비']
    }
  },
  {
    id: 'best-08',
    image: process.env.PUBLIC_URL+'/lika_img/product_8.jpg',
    banner: process.env.PUBLIC_URL+'/lika_img/product_8_1.jpg',
    detail: [
      process.env.PUBLIC_URL+'/lika_img/detail8/detail8_1.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail8/detail8_2.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail8/detail8_3.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail8/detail8_4.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail8/detail8_5.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail8/detail8_6.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail8/detail8_7.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail8/detail8_8.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail8/detail8_9.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail8/detail8_10.gif',
      process.env.PUBLIC_URL+'/lika_img/detail8/detail8_11.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail8/detail8_12.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail8/detail8_13.gif',
      process.env.PUBLIC_URL+'/lika_img/detail8/detail8_14.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail8/detail8_15.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail8/detail8_16.jpg'
    ],
    desc: '79,000원',
    title: '포근니트',
    price: '55,300원',
    text: '오직 리카리카에서 만나볼 수 있는 자체 편직, 귀엽고 포근한 니트!',
    sort: '패션',
    option: {
      size: ['SM','M','L','XL','2XL'],
      color: ['토끼','곰돌이','코알라']
    }
  },
  {
    id: 'best-09',
    image: process.env.PUBLIC_URL+'/lika_img/product_9.jpg',
    banner: process.env.PUBLIC_URL+'/lika_img/product_9_1.jpg',
    detail: [
      process.env.PUBLIC_URL+'/lika_img/detail9/detail9_1.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail9/detail9_2.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail9/detail9_3.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail9/detail9_4.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail9/detail9_5.gif',
      process.env.PUBLIC_URL+'/lika_img/detail9/detail9_6.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail9/detail9_7.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail9/detail9_8.gif',
      process.env.PUBLIC_URL+'/lika_img/detail9/detail9_9.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail9/detail9_10.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail9/detail9_11.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail9/detail9_12.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail9/detail9_13.jpg'
    ],
    desc: '69,000원',
    title: '눈사람 6온스 패딩',
    price: '48,300원',
    text: '눈처럼 가볍고, 따뜻함 가득한 눈사람 6온스 패딩',
    sort: '패션',
    option: {
      size: ['SM','M','L','XL','2XL'],
      color: ['스카이블루','그레이']
    }
  },
  {
    id: 'best-10',
    image: process.env.PUBLIC_URL+'/lika_img/product_10.jpg',
    banner: process.env.PUBLIC_URL+'/lika_img/product_10_1.jpg',
    detail: [
      process.env.PUBLIC_URL+'/lika_img/detail10/detail10_1.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail10/detail10_2.gif',
      process.env.PUBLIC_URL+'/lika_img/detail10/detail10_3.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail10/detail10_4.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail10/detail10_5.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail10/detail10_6.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail10/detail10_7.gif',
      process.env.PUBLIC_URL+'/lika_img/detail10/detail10_8.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail10/detail10_9.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail10/detail10_10.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail10/detail10_11.gif',
      process.env.PUBLIC_URL+'/lika_img/detail10/detail10_12.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail10/detail10_13.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail10/detail10_14.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail10/detail10_15.gif',
      process.env.PUBLIC_URL+'/lika_img/detail10/detail10_16.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail10/detail10_17.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail10/detail10_18.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail10/detail10_19.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail10/detail10_20.jpg'
    ],
    desc: '28,000원',
    title: '진드기 때찌 슬리브리스',
    price: '23,800원',
    text: '뿌리지 말고, 바르지 말고, 쓱 입히기만 하세요!',
    sort: '패션',
    option: {
      size: ['SM','M','L','XL','2XL'],
      color: ['사자(그린)','호랑이(블루)']
    }
  },
  {
    id: 'best-11',
    image: process.env.PUBLIC_URL+'/lika_img/product_11.jpg',
    banner: process.env.PUBLIC_URL+'/lika_img/product_11_1.jpg',
    detail: [
      process.env.PUBLIC_URL+'/lika_img/detail11/detail11_1.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail11/detail11_2.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail11/detail11_3.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail11/detail11_4.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail11/detail11_5.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail11/detail11_6.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail11/detail11_7.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail11/detail11_8.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail11/detail11_9.jpg'
    ],
    desc: '10,000원',
    title: '삼각김밥 노즈워크 장난감',
    price: '9,000원',
    text: '뿌리지 말고, 바르지 말고, 쓱 입히기만 하세요!',
    sort: '토이',
    option: {
      size: ['단품'],
      color: ['단품']
    }
  },
  {
    id: 'best-12',
    image: process.env.PUBLIC_URL+'/lika_img/product_12.jpg',
    banner: process.env.PUBLIC_URL+'/lika_img/product_12_1.jpg',
    detail: [
      process.env.PUBLIC_URL+'/lika_img/detail12/detail12_1.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail12/detail12_2.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail12/detail12_3.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail12/detail12_4.gif',
      process.env.PUBLIC_URL+'/lika_img/detail12/detail12_5.gif',
      process.env.PUBLIC_URL+'/lika_img/detail12/detail12_6.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail12/detail12_7.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail12/detail12_8.gif',
      process.env.PUBLIC_URL+'/lika_img/detail12/detail12_9.jpg',
      process.env.PUBLIC_URL+'/lika_img/detail12/detail12_10.gif',
      process.env.PUBLIC_URL+'/lika_img/detail12/detail12_11.gif'
    ],
    desc: '13,000원',
    title: '카페 노즈워크 장난감',
    price: '11,000원',
    text: '리카리카 카페 오픈! 버터향 가득한 갓 구운 소금빵, 달달하고 폭신한 딸기케이크, 디저트와 함께할 에스프레소 한 잔',
    sort: '토이',
    option: {
      size: ['단품'],
      color: ['소금빵','딸기케이크','에스프레소']
    }
  },
  
]
export default data